import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=4b52264e&"
import script from "./HomeLayout.vue?vue&type=script&lang=ts&"
export * from "./HomeLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports